export const MTLabelMap: Record<string, string> = {
  define: 'Define',
  upload: 'Upload',
  prepare: 'Prepare',
  compute: 'Compute',
  allocate: 'Allocate',
  returns: 'Returns',
  reports: 'Reports',
}

// Sub-module display labels (API module_name → user-facing label)
export const MTSubModuleLabelMap: Record<string, string> = {
  // Uppercase codes from navigation API
  SERVICE_MASTER: 'Service master',
  SECTION_KEYWORD: 'Service keyword',
  RULE_SETTING: 'Rule setting',
  DUPLICATION_RULE: 'Duplication rule',
  PAYEE_MASTER: 'Payee master',
  NATURE_OF_SERVICE: 'Nature of service master',
  DTAA_MASTER: 'Dtaa master',
  // Lowercase fallbacks
  section_service_master: 'Service master',
  service_master: 'Service master',
  section_service_keywords: 'Service keyword',
  service_keywords: 'Service keyword',
  vendor_master: 'Vendor master',
  vendor_details: 'Vendor details',
  rule_setting: 'Rule setting',
  duplication_rule: 'Duplication rule',
  payee_master: 'Payee master',
}
